import { Flex, Switch } from '@chakra-ui/react';
import { UseMutationResult } from '@tanstack/react-query';
import { TooltipStandard } from 'components/tooltip/TooltipStandard';
import { useEffect, useState } from 'react';

import switchMessanges from './variable/switchMessanges';
interface SwitchProps<T extends Array<any>, ExtraBody extends any> {
	id: number;
	checked: boolean;
	convertToUpdateInput: (p: { id: number }) => T;
	keyBody: string;
	useEdit: (...args: T) => UseMutationResult<any, any, any, any>;
	extraBody?: ExtraBody;
	isDisabled?: boolean;
	module: string;
}
export function SwitchComponent<T extends Array<any>, ExtraBody>(
	props: SwitchProps<T, ExtraBody>
) {
	const {
		id,
		checked,
		convertToUpdateInput,
		keyBody,
		useEdit,
		extraBody,
		isDisabled,
		module,
	} = props;
	const label =
		switchMessanges[module]?.[checked ? 'check' : 'notCheck'] || '';

	const [isToggleChecked, setIsToggleChecked] = useState(checked);

	useEffect(() => {
		setIsToggleChecked(checked);
	}, [id, checked]);
	const { mutate, isError, isPending } = useEdit(
		...convertToUpdateInput({ id })
	);
	const updateItem = (): void => {
		const body = {
			[keyBody]: !checked,
			...(extraBody || {}),
		};
		mutate(body);
	};

	useEffect(() => {
		if (isError) {
			setIsToggleChecked(checked);
		}
	}, [isError]);

	return (
		<Flex>
			<TooltipStandard label={label}>
				<Switch
					colorScheme='green'
					size='sm'
					isChecked={isToggleChecked}
					onChange={updateItem}
					isDisabled={isPending || isDisabled}
				/>
			</TooltipStandard>
		</Flex>
	);
}
